<template>
  <div class="mb-5">
    <router-link :to="{name: 'terms-of-service.list'}">See other terms</router-link>
    <div class="text-center">
      <h2>Livestream <br>(Alexa)</h2>
    </div>

    <hr />
    <div>
      <p>Effective Date: 05/10/2026</p>
    </div>
    <hr />

    <div>
      <h3>1. Introduction</h3>
      <p>Welcome to the OpenMasjid Alexa skill ("Skill"). These Terms of Service ("Terms") govern your use of the Skill. The Skill is owned and operated by OpenMasjid.io ("we," "us," or "our"). By using the Skill, you agree to be bound by these Terms. If you disagree with any part of these Terms, you may not use the Skill.</p>
    </div>
    <hr />

    <div>
      <h3>2. Use of the Skill</h3>
      <p><strong>2.1</strong> You must be at least 13 years old to use the Skill. By using the Skill, you represent and warrant that you are at least 13 years old and of legal capacity to enter into a binding agreement.</p>
      <p><strong>2.2</strong> To link an Alexa device, you need the OpenMasjid mobile app and a signed-in OpenMasjid account. The Skill speaks a 6-digit code. You enter that code in the OpenMasjid mobile app. The Skill does not use an Alexa account password.</p>
      <p><strong>2.3</strong> You are responsible for the OpenMasjid account you use to enter the code, and for the Alexa account on the device. You are responsible for activity under those accounts.</p>
      <p><strong>2.4</strong> Audio plays only while the masjid is on air, and it is delayed by a few seconds. If the masjid is not on air, the Skill tells you and does not play a stream. A salah reminder or a live-audio notification does not start playback. You open the Skill to listen.</p>
      <p><strong>2.5</strong> You agree to use the Skill in accordance with all applicable laws and regulations.</p>
      <p><strong>2.6</strong> You agree not to use the Skill for any purpose that is unlawful or unauthorized. This includes, but is not limited to:</p>
      <ul>
        <li>Infringing on the intellectual property rights of others.</li>
        <li>Transmitting any harmful or malicious code, such as viruses or worms.</li>
        <li>Interfering with or disrupting the Skill or any servers or networks connected to the Skill.</li>
        <li>Impersonating any person or entity.</li>
        <li>Collecting or storing personal information about other users without their express consent.</li>
      </ul>
    </div>
    <hr />

    <div>
      <h3>3. Intellectual Property</h3>
      <p>The Skill and all content and materials included in the Skill (including, but not limited to, text, graphics, logos, and software) are the property of OpenMasjid.io or its licensors and are protected by copyright, trademark, and other intellectual property laws. Audio from a masjid belongs to that masjid or its licensors.</p>
    </div>
    <hr />

    <div>
      <h3>4. Disclaimers</h3>
      <p>THE SKILL IS PROVIDED "AS IS" AND WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED. WE DISCLAIM ALL WARRANTIES, INCLUDING, BUT NOT LIMITED TO, WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT. WE DO NOT WARRANT THAT THE SKILL WILL BE UNINTERRUPTED OR ERROR-FREE, THAT A MASJID WILL BE ON AIR, THAT SALAH TIMES OR REMINDERS WILL BE ACCURATE, THAT DEFECTS WILL BE CORRECTED, OR THAT THE SKILL IS FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS.</p>
    </div>
    <hr />

    <div>
      <h3>5. Limitation of Liability</h3>
      <p>WE WILL NOT BE LIABLE FOR ANY DAMAGES ARISING OUT OF OR RELATED TO YOUR USE OF THE SKILL, INCLUDING, BUT NOT LIMITED TO, DIRECT, INDIRECT, INCIDENTAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES.</p>
    </div>
    <hr />

    <div>
      <h3>6. Termination</h3>
      <p>We may terminate your access to the Skill at any time for any reason, with or without notice.</p>
    </div>
    <hr />

    <div>
      <h3>7. Governing Law</h3>
      <p>These Terms shall be governed by and construed in accordance with the laws of the United Kingdom, without regard to its conflict of law provisions.</p>
    </div>
    <hr />

    <div>
      <h3>8. Entire Agreement</h3>
      <p>These Terms constitute the entire agreement between you and us regarding your use of the Skill.</p>
    </div>
    <hr />

    <div>
      <h3>9. Severability</h3>
      <p>If any provision of these Terms is held to be invalid or unenforceable, such provision shall be struck and the remaining provisions shall remain in full force and effect.</p>
    </div>
    <hr />

    <div>
      <h3>10. Changes to these Terms</h3>
      <p>We may update these Terms at any time. We will notify you of any changes by posting the new Terms on this page. You are advised to consult these Terms regularly for any changes. By continuing to use the Skill after the revised Terms are posted, you agree to be bound by the new Terms.</p>
    </div>
    <hr />

    <div>
      <h3>Contact Us</h3>
      <p>If you have any questions about these Terms, please contact us at:<br /> <a href="mailto:talha@arcticprism.com">talha@arcticprism.com</a></p>
    </div>
  </div>
</template>

<script>
export default {
  name: "LivestreamAlexaTermsOfService"
}
</script>

<style scoped>

</style>
